var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._g(_vm._b({ref:"select",attrs:{"clearable":"","hide-details":"","dense":"","label":_vm.$t(_vm.label),"value":_vm.value},on:{"mousedown":function($event){return _vm.$refs.select.focus()},"change":function($event){return _vm.$refs.select.blur()}}},'v-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }